import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M8 19v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 14v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 19v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 14v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 21v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 16v1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CloudDrizzle";
const CloudDrizzle = memo(themed(Icon));
export {
  CloudDrizzle
};
//# sourceMappingURL=cloud-drizzle.js.map
